<template>
  <div id="knowledge-base-page">

    <!-- KNOWLEDGE BASE CARDS  -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base" >
      <a :href="`https://api.whatsapp.com/send?phone=${appWhatsAppMobileNumber}`">
        <vx-card class="text-center cursor-pointer">
          <img src="@/assets/images/pages/whats.png" alt="graphic" width="96" class="mx-auto mb-4" />
          <h4 class="mb-2">{{appNumberWhats}}</h4>
          <small>Atendimento pessoal pelo WhatsApp.</small>
        </vx-card>
      </a>
      </div>

      <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base" >
      <a :href="`tel:${appWhatsAppMobileNumber}`">
        <vx-card class="text-center cursor-pointer">
          <img src="@/assets/images/pages/telefone.png" alt="graphic" width="96" class="mx-auto mb-4" />
          <h4 class="mb-2">{{appNumber}}</h4>
          <small>Atendimento de Segunda a Sexta das 09:00 as 18:00.</small>
        </vx-card>
      </a>
      </div>

      <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base" >
      <router-link to="/pages/faq">
        <vx-card class="text-center cursor-pointer">
          <img src="@/assets/images/pages/faq.png" alt="graphic" width="96" class="mx-auto mb-4" />
          <h4 class="mb-2">FAQ</h4>
          <small>Tire todas as suas dúvidas referente ao {{appName}}.</small>
        </vx-card>
      </router-link>
      </div>

      <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base" >
      <a :href="`${appSuporte}` " >
        <vx-card class="text-center cursor-pointer">
          <img src="@/assets/images/pages/email.png" alt="graphic" width="96" class="mx-auto mb-4" />
          <h4 class="mb-2">Criar Ticket</h4>
          <small>Fale conosco via email, respondemos em no máximo 48 horas.</small>
        </vx-card>
      </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      appNumberWhats: process.env.VUE_APP_TELEFONE_FORMATADO_WHATSAPP,
      appNumber: process.env.VUE_APP_TELEFONE_FORMATADO,
      appWhatsAppMobileNumber: process.env.VUE_APP_TELEFONE_NAO_FORMATADO_WHATSAPP,
      appSuporte: process.env.VUE_APP_LINK_SUPORTE
    };
  },
  computed: {
    filteredKB() {
      return this.kb.filter(
        (item) =>
          item.title.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase())
      );
    },
  },
  methods: {},
  components: {},
};
</script>

